import func from "../utils/func";

export default {
    namespaced: true,
    state: {
        selectKey: [],
        breadcrumbList: [],
        scrollWidth: func.getScrollWidth(),
        clientWidth: document.body.clientWidth,
        clientHeight: document.body.clientHeight
    },
    mutations: {
        resize(state) {
            state.clientWidth = document.body.clientWidth;
            state.clientHeight = document.body.clientHeight;
        },
        refresh(state, route) {
            state.selectKey = [route.name];
            let parts = route.name.split(".");
            for (let i = 0; i < parts.length; i++) {
                parts.pop(); // 全部链路上的路由
                state.selectKey.push(parts.join("."))
            }
            state.breadcrumbList = [];
            route.matched.forEach((item) => {
                if (func.hasMetaTitle(item)) {
                    state.breadcrumbList.push({
                        name: item.name,
                        text: item.meta.title
                    })
                }
            });
        }
    },
    getters: {
        contentWidth: (state) => state.clientWidth - state.scrollWidth,
        contentHeight: (state) => state.clientHeight - 54
    }
};
